export default function OptimizedImage ({
  src,
  alt,
  width,
  height,
  className = '',
  loading = 'lazy',
  priority = false,
  onClick,
  style = {},
  ...props
}) {
  const loadingStrategy = priority ? 'eager' : loading;
  
  const imageProps = {
    src,
    alt,
    className,
    loading: loadingStrategy,
    style: {
      maxWidth: '100%',
      ...style
    },
    ...props
  };

  // Add dimensions if provided for better CLS
  if (width) imageProps.width = width;
  if (height) imageProps.height = height;
  
  // Add click handler if provided
  if (onClick) {
    imageProps.onClick = onClick;
    imageProps.onKeyDown = onKeyDown;
    imageProps.role = "button";
    imageProps.tabIndex = 0;
    imageProps.style = { cursor: "pointer", ...imageProps.style };
    imageProps["aria-label"] = alt || "image";
  }

  return <img {...imageProps} />;
};